export default __webpack_public_path__ + "b50584745d7c9d5d1ba3da5feb200f5d.svg";